import React from 'react';
import PropTypes from 'prop-types';
import {url} from 'src/shared/utils/url';

export const DeflectionTV = ({className}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" className={className} role="img" aria-hidden="true">
    <defs>
      <linearGradient id="deflection-tv-gradient" x1="-86.75" y1="80" x2="-87.3" y2="80.43" gradientTransform="matrix(56.32, 0, 0, -44.49, 4926.38, 3615.61)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#3c4a5b" />
        <stop offset="1" stopColor="#44566b" />
      </linearGradient>
    </defs>
    <path fill="#364250" fillRule="evenodd" d="M75,14H5a1,1,0,0,0-1,1V60.81a1,1,0,0,0,1,1h9.77L11.61,66h4.93l3.21-4.18H59.57L62.78,66h4.93L64.5,61.85H75a1,1,0,0,0,1-1V15A1,1,0,0,0,75,14Z" />
    <path fill={url('#deflection-tv-gradient')} fillRule="evenodd" d="M4.86,14a.87.87,0,0,0-.86.87V61a.86.86,0,0,0,.86.86H64.61L16.92,14Z" />
    <polygon fill="#44566b" fillRule="evenodd" points="7.72 58.49 72.65 58.49 72.65 17.71 7.72 17.71 7.72 58.49" />
    <polygon fill="#51677a" fillRule="evenodd" points="20.29 17.44 7.45 17.44 7.45 58.22 60.56 58.22 20.29 17.44" />
    <path fill="#1bd1ba" fillRule="evenodd" d="M48.84,26.08a.31.31,0,0,0-.53-.16l-1.42,1.49a12.82,12.82,0,0,0-6.9-2A12.69,12.69,0,0,0,27.22,38a1,1,0,0,0,2,0A10.72,10.72,0,0,1,40,27.35a10.87,10.87,0,0,1,5.52,1.5l-1.17,1.22a.3.3,0,0,0,.2.51l4.61.35a.3.3,0,0,0,.33-.34ZM30.84,49.69a.31.31,0,0,0,.52.18l1.47-1.46A12.8,12.8,0,0,0,52.75,38.34a1,1,0,0,0-1-1,1,1,0,0,0-1,.95A10.74,10.74,0,0,1,39.72,48.64,11,11,0,0,1,34.24,47l1.2-1.2a.3.3,0,0,0-.19-.51l-4.6-.47a.3.3,0,0,0-.33.34Z" />
  </svg>
);

DeflectionTV.propTypes = {
  className: PropTypes.string,
};
